import React from "react";
import { useParentChildren } from "@/hooks/useParentChildren";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Heart } from "lucide-react";

/**
 * Compact bar shown at the top of parent-scoped pages when the parent has >1 child.
 * Hidden when there's a single child (no need to choose).
 */
export default function ChildSelector({ className = "" }) {
  const { children, selected, setSelected, showSelector } = useParentChildren();
  if (!showSelector || !selected) return null;
  return (
    <div
      className={`flex items-center gap-3 p-3 rounded-2xl bg-primary/8 border border-primary/25 ${className}`}
      data-testid="child-selector-bar"
    >
      <div className="h-8 w-8 rounded-xl bg-primary/15 grid place-items-center">
        <Heart className="h-4 w-4 text-primary" />
      </div>
      <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">
        Viewing child
      </div>
      <Select value={selected.id} onValueChange={setSelected}>
        <SelectTrigger className="rounded-xl h-9 w-56" data-testid="child-selector">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {children.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`child-option-${c.id}`}>
              {c.name} · {c.class_name || "—"}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
